import {
  KEY_HAS_UNREAD_NOTIFICATIONS,
  KEY_SPEECHBUBBLE_UNREAD_NOTIFICATIONS,
  KEY_UNREAD_NOTIFICATIONS_COUNT,
} from '../const/common';
import { log } from '../utils/debug';
import Event from '../const/event';

export async function updateSpeechbubblePanelUnread(subscriptionManager) {
  const specialLinks = document.querySelectorAll("a[href='#cleverpush-bell-speechbubble']");
  if (specialLinks.length) {
    let unread;
    try {
      const isSubscribed = await subscriptionManager.isSubscribed();
      const notificationCount = Number(localStorage.getItem(KEY_UNREAD_NOTIFICATIONS_COUNT));
      if (isSubscribed) {
        if (!sessionStorage.getItem(KEY_SPEECHBUBBLE_UNREAD_NOTIFICATIONS)) {
          import('../utils').then(async ({ hasUnreadNotifications }) => {
            unread = await hasUnreadNotifications(subscriptionManager);
          });
          sessionStorage.setItem(KEY_SPEECHBUBBLE_UNREAD_NOTIFICATIONS, unread);
        } else if (notificationCount) {
          unread = true;
        }
      }
      specialLinks.forEach((link) => {
        const existingCounter = link.querySelector('.cleverpush-unread-notifications-count');
        if (existingCounter) {
          existingCounter.parentNode.removeChild(existingCounter);
        }
        if (unread && isSubscribed) {
          link.classList.add(KEY_HAS_UNREAD_NOTIFICATIONS);
          if (notificationCount) {
            import('../utils').then(({ appendCounterElement }) => {
              appendCounterElement(link);
            });
          }
        } else {
          link.classList.remove(KEY_HAS_UNREAD_NOTIFICATIONS);
        }
      });
    } catch (err) {
      console.info('Error while fetching notifications');
    }
  }
}

export async function initSpeechbubblePanels(context) {
  const specialLinks = document.querySelectorAll("a[href='#cleverpush-bell-speechbubble']");
  if (specialLinks.length) {
    try {
      updateSpeechbubblePanelUnread(context.subscriptionManager);
      context.on(Event.SUBSCRIBED, () => updateSpeechbubblePanelUnread(context.subscriptionManager));
      context.on(Event.UNSUBSCRIBED, () => updateSpeechbubblePanelUnread(context.subscriptionManager));

      specialLinks.forEach((link) => {
        link.addEventListener('click', async (e) => {
          e.preventDefault();
          const isSubscribed = await context.subscriptionManager.isSubscribed();
          if (isSubscribed) {
            context.showSpeechbubbleInlinePanel(link);
          } else {
            context.triggerOptIn(true, (err) => {
              if (err) {
                if (link.classList.contains(KEY_HAS_UNREAD_NOTIFICATIONS)) {
                  link.classList.remove(KEY_HAS_UNREAD_NOTIFICATIONS);
                }
              }
            });
          }
        });
      });
    } catch (error) {
      log.error('Error while initializing speechbubble panels', error);
    }
  }
}
